// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__5rz87","content":"layout_content__XzT01","main":"layout_main__88FzF"};